import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router-dom';

import {Icon, ThemeContext} from '../';
import * as panelActions from '../../../actions/panelNav';

const LinkWrap = (props) => {
  const {text, icon, iconSize, type, theme, size, to, href, target,
    renderInPanel, renderInFooter, color, bgColor, className} = props;
  const classes = classNames(
    {
      [`${type}`]: Boolean(type),
      [className]: Boolean(className),
      [`button_${theme}`]: type === 'button' && Boolean(theme),
      [`button_size_${size}`]: type === 'button' && Boolean(size),
    }
  );
  const linkProps = {
    role: type === 'button' ? 'button' : '',
    className: classes,
    to,
    href,
    target,
  };

  if (props.onClick) {
    linkProps.onClick = (evt) => {
      evt.preventDefault();
      return props.onClick();
    };
  }

  const handleLinkButtonClick = (evt) => {
    evt.preventDefault();
    try {
      const {panelMethod, callback} = props;
      props[panelMethod]();
      if (callback) {
        props[callback]();
      }
    } catch (e) {
      debugger;
      console.log(e);
    }
  };

  return (
    <ThemeContext.Consumer>
      {(template) => {
        const styles = {backgroundColor: bgColor};

        if (type === 'button') {
          if (theme === 'primary') {
            styles.backgroundColor = template.primaryColor;
          }
          if (theme === 'secondary') {
            styles.color = template.primaryColor;
          }
        } else {
          styles.color = color || template.primaryColor;
        }

        let _pageLink;

        if (renderInFooter) {
          _pageLink = (<Link {...linkProps} onClick={handleLinkButtonClick} style={styles}>
            {icon && (<Icon
              glyph={icon}
              size={iconSize}
            />)}
            {text}
          </Link>);
        } else if (href) {
          _pageLink = (<a {...linkProps} style={styles}>
            {icon && (<Icon
              glyph={icon}
              size={iconSize}
            />)}
            {text}
          </a>);
        } else {
          _pageLink = (<Link {...linkProps} style={styles}>
            {icon && (<Icon
              glyph={icon}
              size={iconSize}
            />)}
            {text}
          </Link>);
        }

        const _panelLink = (
          <button className="link-button" style={styles} onClick={handleLinkButtonClick}>{text}</button>
        );

        const _link = renderInPanel ? _panelLink : _pageLink;

        return _link;
      }}
    </ThemeContext.Consumer>
  );
};

LinkWrap.propTypes = {
  // eslint-disable-next-line react/require-default-props
  onClick: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  callback: PropTypes.string,
  text: PropTypes.string,
  theme: PropTypes.string,
  size: PropTypes.string,
  to: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  type: PropTypes.string,
  color: PropTypes.string,
  bgColor: PropTypes.string,
  className: PropTypes.string,
  renderInPanel: PropTypes.bool,
  renderInFooter: PropTypes.bool,
  panelMethod: PropTypes.string,
  target: PropTypes.string,
};
LinkWrap.defaultProps = {
  to: '#',
  target: '_self',
  href: '',
  text: '',
  size: 'xs',
  theme: '',
  icon: '',
  iconSize: 'xs',
  type: 'link',
  color: '',
  bgColor: '',
  className: '',
  renderInPanel: false,
  renderInFooter: false,
  panelMethod: null,
};

const mapDispatchToProps = dispatch => (
  {
    dispatch,
    ...bindActionCreators({
      ...panelActions,
    }, dispatch),
  }
);

const mapStateToProps = (state, ownProps) => {
  const {panelNav} = state;

  return (
    {
      ...ownProps,
      panel: panelNav,
    }
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkWrap);
